"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAlignments = exports.NavigationTypes = void 0;

var _designLanguage = require("@doordash/design-language");

var NavigationTypes = {
  Back: {
    icon: _designLanguage.Icon.Types.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: _designLanguage.Icon.Types.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: _designLanguage.Icon.Types.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};
exports.NavigationTypes = NavigationTypes;
var TextAlignments = {
  Left: _designLanguage.Text.TextAlignments.Left,
  Center: _designLanguage.Text.TextAlignments.Center
};
exports.TextAlignments = TextAlignments;